module.exports = __webpack_public_path__ + "img/insuranceCompanies.514c4e46.svg";